import './related-source.scss';

/**
 * version    1.0
 * class      <type> (RelatedSource)
 * classdesc  Related Source: contain title, badge, occhiello and cta
 */
export class RelatedSource {}
